"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemDemo = void 0;
const SankeyMenuExamples_1 = require("open-sankey/dist/SankeyMenuExamples");
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = __importDefault(require("react"));
const itemDemo = (t, exemple_menu, url_prefix, data, set_data, multi_selected_nodes, multi_selected_links, multi_selected_label, launch, reinitialization, set_user_scale) => {
    return react_1.default.createElement(react_bootstrap_1.NavDropdown, { title: t('Menu.Exemples'), id: "exemples" },
        react_1.default.createElement(SankeyMenuExamples_1.ExempleItem, { exemple_menu: exemple_menu, url_prefix: url_prefix, data: data, set_data: set_data, current_path: '', multi_selected_nodes: multi_selected_nodes, multi_selected_links: multi_selected_links, multi_selected_label: multi_selected_label, launch: launch, reinitialization: reinitialization, set_user_scale: set_user_scale }));
};
exports.itemDemo = itemDemo;
